import PropTypes from 'prop-types';

export const freeOfChargeRuleUserPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
});

export const freeOfChargeRulePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  userList: PropTypes.arrayOf(freeOfChargeRuleUserPropType).isRequired,
});
